import ChangePasswordPanel from "./changePasswordPanel.container";

export default ChangePasswordPanel;